import { render } from "./cookie-consent.vue?vue&type=template&id=10423724&scoped=true&ts=true"
import script from "./cookie-consent.vue?vue&type=script&lang=ts"
export * from "./cookie-consent.vue?vue&type=script&lang=ts"

import "./cookie-consent.vue?vue&type=style&index=0&id=10423724&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10423724"]])

export default __exports__